import styled from 'styled-components';

export const ConteinerLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
